import { render, staticRenderFns } from "./SettingsBottomNav.vue?vue&type=template&id=539bb333"
import script from "./SettingsBottomNav.vue?vue&type=script&lang=js"
export * from "./SettingsBottomNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports